import { useStaticQuery, graphql } from 'gatsby'

export const useInteriorHeroDefaultQuery = () => {
  const { wp } = useStaticQuery(graphql`
    query InteriorHeroDefaultQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            heroBadge {
              localFile {
                publicURL
              }
            }
            interiorPage {
              heroImageDefault {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: WEBP)
                  }
                }
              }
              buttonText
            }
          }
        }
      }
    }
  `)
  return wp.acfOptionsCommonItems.commonItems
}
